import i18n from './i18n';
import moment from 'moment/moment';
import { AccountOrderFieldsFragment } from '@/types';
import { formatShortDate } from './date';

export const formatOrderDeliveryTime = (order: AccountOrderFieldsFragment) => {
  const invoiceDate = order.order_invoices?.[0]?.invoice_date
    ? moment(order.order_invoices[0].invoice_date)
    : null;
  const pepperDeliveryDate = moment(
    order.supplier_accepted_delivery_time ||
      order.restaurant_desired_delivery_time,
  );
  const dateMoment = invoiceDate
    ? moment.max(invoiceDate, pepperDeliveryDate)
    : pepperDeliveryDate;

  if (dateMoment.isValid()) {
    const now = moment();
    if (now.isBefore(dateMoment)) {
      return i18n.t('next_order_date', {
        date: formatShortDate(dateMoment),
      });
    }

    const daysFromLastOrder = now.diff(dateMoment, 'days');

    if (daysFromLastOrder === 0) {
      return i18n.t('last_order_today');
    } else if (daysFromLastOrder === 1) {
      return i18n.t('last_order_days_ago_singular', {
        count: daysFromLastOrder,
      });
    } else {
      return i18n.t('last_order_days_ago', {
        count: daysFromLastOrder,
      });
    }
  }

  // Fallback if order is missing both supplier and restaurant delivery time
  return '';
};

export const formatOfflineDataStatusDate = (lastDownloaded: Date) => {
  if (!lastDownloaded) {
    return '';
  }

  const lastDownloadedMoment = moment(lastDownloaded);
  if (!lastDownloadedMoment.isValid()) {
    return '';
  }

  const now = moment();
  const minutesSinceDownload = now.diff(lastDownloadedMoment, 'minutes');
  const hoursSinceDownload = now.diff(lastDownloadedMoment, 'hours');
  const daysSinceDownload = now.diff(lastDownloadedMoment, 'days');

  if (minutesSinceDownload < 60) {
    return i18n.t(
      minutesSinceDownload <= 1
        ? 'synced_subtitle.minute_singular'
        : 'synced_subtitle.minute_plural',
      {
        minutes: minutesSinceDownload,
      },
    );
  } else if (hoursSinceDownload < 24) {
    return i18n.t(
      hoursSinceDownload <= 1
        ? 'synced_subtitle.hour_singular'
        : 'synced_subtitle.hour_plural',
      {
        hours: hoursSinceDownload,
      },
    );
  } else {
    return i18n.t(
      daysSinceDownload <= 1
        ? 'synced_subtitle.day_singular'
        : 'synced_subtitle.day_plural',
      {
        days: daysSinceDownload,
      },
    );
  }
};
